import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';
import { ServiceCatalogModel } from '../_models/service-catalog.model';

export enum ServiceCatalogActionTypes {
  ServiceCatalogOnServerCreated = '[Edit Service Catalog Dialog] Service Catalog On Server Created',
  ServiceCatalogCreated = '[Edit Service Catalog Dialog] Service Catalog Created',
  ServiceCatalogOnServerUpdated = '[Edit Service Catalog Dialog] Service Catalog On Server Updated',
  ServiceCatalogUpdated = '[Edit Service Catalog Dialog] Service Catalog Updated',
  OneServiceCatalogOnServerDeleted = '[Service Catalogs List Page] One Service Catalog On Server Deleted',
  OneServiceCatalogDeleted = '[Service Catalogs List Page] One Service Catalog Deleted',
  ServiceCatalogsPageRequested = '[Service Catalogs List Page] Service Catalogs Page Requested',
  ServiceCatalogsPageLoaded = '[Service Catalogs API] Service Catalogs Page Loaded',
  ServiceCatalogsPageCancelled = '[Service Catalogs API] Service Catalogs Page Cancelled',
  ServiceCatalogsPageToggleLoading = '[Service Catalogs] Service Catalogs Page Toggle Loading',
  ServiceCatalogActionToggleLoading = '[Service Catalogs] Service Catalog Action Toggle Loading',
  ThrowServiceCatalogError = '[Service Catalogs] Throw Service Catalog Error',
  FireServiceCatalogSuccess = '[Service Catalogs] Fire Service Catalog Success',
}

export class ServiceCatalogOnServerCreated implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogOnServerCreated;
  constructor(public payload: { serviceCatalog: ServiceCatalogModel }) {}
}

export class ServiceCatalogCreated implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogCreated;
  constructor(public payload: { serviceCatalog: ServiceCatalogModel }) {}
}

export class ServiceCatalogOnServerUpdated implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogOnServerUpdated;
  constructor(
    public payload: {
      partialServiceCatalog: Update<ServiceCatalogModel>;
      serviceCatalog: ServiceCatalogModel;
    },
  ) {}
}

export class ServiceCatalogUpdated implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogUpdated;
  constructor(
    public payload: {
      partialServiceCatalog: Update<ServiceCatalogModel>;
      serviceCatalog: ServiceCatalogModel;
    },
  ) {}
}

export class OneServiceCatalogOnServerDeleted implements Action {
  readonly type = ServiceCatalogActionTypes.OneServiceCatalogOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class OneServiceCatalogDeleted implements Action {
  readonly type = ServiceCatalogActionTypes.OneServiceCatalogDeleted;
  constructor(public payload: { id: number }) {}
}

export class ServiceCatalogsPageRequested implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class ServiceCatalogsPageLoaded implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogsPageLoaded;
  constructor(
    public payload: {
      serviceCatalogs: ServiceCatalogModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class ServiceCatalogsPageCancelled implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogsPageCancelled;
}

export class ServiceCatalogsPageToggleLoading implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ServiceCatalogActionToggleLoading implements Action {
  readonly type = ServiceCatalogActionTypes.ServiceCatalogActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowServiceCatalogError implements Action {
  readonly type = ServiceCatalogActionTypes.ThrowServiceCatalogError;
  constructor(public payload: { error: any }) {}
}

export class FireServiceCatalogSuccess implements Action {
  readonly type = ServiceCatalogActionTypes.FireServiceCatalogSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type ServiceCatalogActions =
  | ServiceCatalogOnServerCreated
  | ServiceCatalogCreated
  | ServiceCatalogOnServerUpdated
  | ServiceCatalogUpdated
  | OneServiceCatalogOnServerDeleted
  | OneServiceCatalogDeleted
  | ServiceCatalogsPageRequested
  | ServiceCatalogsPageLoaded
  | ServiceCatalogsPageCancelled
  | ServiceCatalogsPageToggleLoading
  | ServiceCatalogActionToggleLoading
  | ThrowServiceCatalogError
  | FireServiceCatalogSuccess;
